/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import countries from "countries-list";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { updateUser } from "../../../../redux/auth/authSlice";
import { OTPModalUI } from "./OTPModalUI";
import { CiCircleCheck } from "react-icons/ci";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const PersonalInformation = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [tooltipError, setTooltipError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [personalData, setPersonalData] = useState({});
  const [isEmailSent, setIsEmailSent] = useState({
    isOldEmailVerified: false,
    isNewEmailVerified: false,
  });
  const inputRefs = useRef([]);
  const [OTPModal, setOTPModal] = useState(0);
  const [OTPField, setOTPField] = useState(new Array(4).fill(""));
  const [counter, setCounter] = useState(300);

  const [occupation, setOccupation] = useState([
    {
      occupationId: 1,
      name: "Select Your Occupation",
      createdBy: 1,
      createdDate: "2022-12-05T13:17:29.3286288",
      updatedBy: 1,
      updatedDate: "2022-12-05T13:17:27.1844533",
      isDelete: false,
    },
  ]);

  const user = useSelector((state) => state.auth.user);
  const language = localStorage.getItem("i18nextLng");
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const {
    watch,
    reset,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const emailValue = watch("email");

  useEffect(() => {
    sessionStorage.setItem(`redirect${user?.userId}AgainToPersonalInfo`, false);
    if (searchParams.get("showModal")) {
      setShowModal(true);
    }
    setTimeout(() => {
      setShowModal(false);
    }, 5000);
  }, []);

  useEffect(() => {
    const fetchPersonalInfo = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`/employee/get/${user?.userId}`);
        reset({
          firstName: res.data.response.firstName,
          lastName: res.data.response.lastName,
          email: res.data.response.email,
          address: res.data.response.address,
          zipCode: res.data.response.zipCode,
          city: res.data.response.city,
          organisation: res.data.response.organisation,
          country: res.data.response.country,
          phoneNo: res.data.response.phoneNo,
          ssn: res.data.response.ssn,
          dateOfBirth: res.data.response.dateOfBirth,
          profession: res.data.response.profession,
          customCheck: res.data.response.customCheck,
          accountType: res.data.response?.accountType,
        });
        setPersonalData(res.data.response);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    fetchPersonalInfo();
    fetchOccupation();
  }, [user?.userId, reset]);

  const fetchOccupation = async () => {
    try {
      const res = await axios.get(`/settings/get-all-occupation-data`);
      setOccupation(res.data?.response);
    } catch (err) {}
  };

  const [toggle, setToggle] = useState(false);

  const onSubmit = async (values) => {
    setToggle(false);
    try {
      setLoading(true);
      const newObj = {
        ...values,
        id: user?.userId,
        ssn: values.ssn ? values.ssn : "",
        lastName: values.lastName,
        dateOfBirth: values.dateOfBirth ? values.dateOfBirth : "",
      };
      const result = await axios.put("/employee/update", newObj);
      if (result?.status === 200) {
        fetchOccupation();
        toast.success(
          t("Your personal information has been updated successfully")
        );
        const userObj = {
          ...user,
          ...values,
        };

        dispatch(updateUser(userObj));
      } else {
        toast.error(t("Something went wrong please try again."));
      }
    } catch (err) {
      toast.error(t(err?.response?.data?.message));
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    if (!event.nativeEvent.inputType) {
      event.target.blur();
    }
  };

  const clear = (event) => {
    event.target.value = "";
  };

  const newDetails = [];
  Object.keys(countries.countries).forEach((code) => {
    // if (countries.countries[code].continent === "EU") {
    newDetails.push(countries.countries[code].name);
    // }
  });
  newDetails.splice(45, 1);

  useEffect(() => {
    setTimeout(() => {
      setTooltipError(false);
    }, 4000);
  }, [tooltipError]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleClose = () => setToggle(false);

  const handleShow = () => {
    setToggle(true);
  };

  const { accountType } = getValues();

  const verifyEmail = async (type) => {
    setLoading(true);
    try {
      const URL = "/settings/generate-otp";
      let body;
      if (type === 1) {
        body = {
          type: 1,
          email: "",
          lang: language,
        };
      }
      if (type === 2) {
        body = {
          type: 2,
          email: emailValue,
          lang: language,
        };
      }
      const result = await axios.post(URL, body);
      if (result?.status === 200) {
        setLoading(false);
        toast.success(t("Email has been successfully sent to your new email"));
        if (type === 1) {
          setOTPModal(1);
          setCounter(300);
        }
        if (type === 2) {
          setOTPModal(2);
          setCounter(300);
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(t(error?.response?.data?.message));
    }
  };

  const handleChangeOTP = async (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...OTPField];

    newOtp[index] = value.substring(value.length - 1);
    setOTPField(newOtp);

    if (value && index < 4 - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
    if (value && index === 3) {
      const combinedOTP = newOtp.join("");

      if (OTPModal === 1) {
        setLoading(true);
        try {
          const URL = `/employee/verify-old?code=${Number(combinedOTP)}`;
          const result = await axios.put(URL);
          if (result?.status === 200) {
            setLoading(false);
            toast.success(t("Your old email has been verified successfully"));
            setIsEmailSent(() => ({ isOldEmailVerified: true }));
            setOTPModal(0);
            setOTPField(new Array(4).fill(""));
          }
        } catch (err) {
          setLoading(false);
          toast.error(t(err?.response?.data?.message));
        }
      }
      if (OTPModal === 2) {
        setLoading(true);
        try {
          const URL = `/employee/verify-new?code=${Number(
            combinedOTP
          )}&email=${emailValue}`;
          const result = await axios.put(URL);
          if (result?.status === 200) {
            setLoading(false);
            toast.success(t("Your new email has been verified successfully"));
            setIsEmailSent(() => ({ isNewEmailVerified: true }));
            setOTPModal(0);
            setOTPField(new Array(4).fill(""));
          }
        } catch (err) {
          setLoading(false);
          toast.error(t(err?.response?.data?.message));
        }
      }
    }
  };

  const resendOTP = async () => {
    setOTPField(new Array(4).fill(""));
    if (OTPModal === 1) {
      verifyEmail(1);
    } else {
      verifyEmail(2);
    }
  };

  const verifyBtnCss = {
    height: "45px",
    marginTop: "13px",
    width: "auto",
    position: "absolute",
    top: "19px",
    right: "0px",
    borderRadius: "0 5px 5px 0",
    fontSize: "14px",
  };

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <div className="page-content personalinformation-page mt-5 prsnl_responve">
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/settings/personal-information"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/installningar/personlig-information"
          />
        )}
      </Helmet>
      {loading && <Loader />}

      <Modal show={toggle} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Personal Information")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("Are you sure you want to update personal information ?")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("No")}
          </Button>
          <Button
            variant="primary"
            className="theme_btn"
            onClick={handleSubmit(onSubmit)}
          >
            {t("Yes")}
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <div className="header">
          <h4 className="accident_ins font-weight-bold">
            {t("Personal data")}
          </h4>
          <span className="text-primary useriddiv">
            {t("User id")}: #{user?.userId ? user?.userId : "---"}
          </span>
          <span className="text-primary useriddiv">
            {t("Created Date")}:{" "}
            {personalData?.createdDate?.split("T")[0] || "---"}
          </span>
        </div>
        <p className="large-margin">
          <span>{t("pihere")}</span>
        </p>
      </div>

      <div className="settings form_back mt-2">
        <div className="personal-info">
          <form onSubmit={handleSubmit(handleShow)} className="col-sm-12 px-1">
            <div>
              <h3>
                <span htmlFor="inputEmail4">
                  {accountType && accountType === 1
                    ? t("Private Account")
                    : t("Business Account")}
                </span>
              </h3>
            </div>
            <div className="row m-auto">
              <div className="form-row d-block w-100">
                <div className={`form-group ${"input-wrapper"}`}>
                  <label htmlFor="inputEmail4">{t("firstName")}</label>
                  <input
                    type="text"
                    id="name"
                    className={`form-control ${
                      errors.firstName ? "is-invalid" : ""
                    }`}
                    {...register("firstName", {
                      required: "Enter the first name",
                    })}
                  />
                </div>

                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4"> {t("lastName")} </label>

                  <input
                    type="text"
                    className={`form-control ${
                      errors.lastName ? "is-invalid" : ""
                    }`}
                    id="surname"
                    {...register("lastName", {
                      required: user?.accountType === 1 || false,
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div
                  className="form-group input-wrapper email"
                  style={{ position: "relative" }}
                >
                  <label htmlFor="inputEmail4">{t("email")}</label>
                  <input
                    type="text"
                    id="email"
                    className="form-control"
                    {...register("email", {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: t("Invalid email address"),
                      },
                      required: true,
                    })}
                  />
                  <div>
                    {isEmailSent?.isNewEmailVerified && (
                      <button disabled>
                        <CiCircleCheck
                          color="#0C9865"
                          style={{
                            height: "35px",
                            marginTop: "16px",
                            width: "auto",
                            position: "absolute",
                            top: "19px",
                            right: "0px",
                            borderRadius: "0 5px 5px 0",
                          }}
                        />
                      </button>
                    )}
                    {isEmailSent?.isOldEmailVerified === false ? (
                      <Button
                        style={verifyBtnCss}
                        disabled={
                          emailValue?.length === 0 ||
                          personalData?.email === emailValue
                        }
                        onClick={() => verifyEmail(1)}
                      >
                        {t("Verify Old Email")}
                      </Button>
                    ) : isEmailSent?.isOldEmailVerified ? (
                      <Button
                        style={verifyBtnCss}
                        onClick={() => verifyEmail(2)}
                        disabled={
                          emailValue?.length === 0 ||
                          personalData?.email === emailValue
                        }
                      >
                        {t("Verify New Email")}
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4"> {t("address")} </label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.address ? "is-invalid" : ""
                    }`}
                    id="address"
                    {...register("address", {
                      required: "Address is must",
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4">{t("zipCode")} </label>
                  <input
                    type="text"
                    id="postal-code"
                    className={`form-control ${
                      errors.zipCode ? "is-invalid" : ""
                    }`}
                    {...register("zipCode", { required: true })}
                  />
                </div>
                <div className="form-group input-wrapper ">
                  <label htmlFor="inputEmail4">{t("city")} </label>

                  <input
                    type="text"
                    id="city"
                    className={`form-control ${
                      errors.city ? "is-invalid" : ""
                    }`}
                    {...register("city", {
                      required: "Enter your city",
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div className="form-group input-wrapper styled-select">
                  <label htmlFor="inputEmail4">{t("country")}</label>
                  <select
                    className={`border-0 p-0 country ${
                      errors.country ? "is-invalid" : ""
                    }`}
                    {...register("country", { required: true })}
                  >
                    <option value="">{t("Select Country")}</option>
                    <option value={"Sweden"}>{"Sweden"}</option>
                    <option value={"USA"}>{"USA"}</option>
                    {newDetails.map((country, index) => (
                      <option key={index} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4">{t("phoneNo")}</label>
                  <input
                    type="number"
                    id="phoneNo"
                    className={`form-control form-control-lg mb-0 ${
                      errors.phoneNo ? "is-invalid" : ""
                    }`}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 17))
                    }
                    {...register("phoneNo", {
                      className: "bg-warning",
                      required: "Phone no is required",
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div className="form-group input-wrapper">
                  {personalData?.dateOfBirth === "" ? (
                    <>
                      <label htmlFor="inputEmail4">
                        {" "}
                        {personalData?.dateOfBirth === ""
                          ? t("ssn")
                          : t("Date Of Birth")}
                      </label>
                      <input
                        type="text"
                        id="social-security-number"
                        readOnly
                        className={`form-control mb-0 ${
                          errors.ssn ? "is-invalid" : ""
                        }`}
                        {...register("ssn", {
                          pattern: {
                            value: /^[0-9+-]+$/,
                          },
                        })}
                      />
                    </>
                  ) : (
                    <>
                      <label htmlFor="inputEmail4">
                        {" "}
                        {personalData?.dateOfBirth === ""
                          ? t("ssn")
                          : t("Date Of Birth")}
                      </label>
                      <input
                        type="text"
                        id="social-security-number"
                        readOnly
                        className={`form-control mb-0 ${
                          errors.dateOfBirth ? "is-invalid" : ""
                        }`}
                        {...register("dateOfBirth", {
                          pattern: {
                            value: /^[0-9+-]+$/,
                          },
                        })}
                      />
                    </>
                  )}
                </div>
                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4">{t("profession")} </label>
                  <input
                    className={`w-100 styled-select select form-control mt-0 ${
                      errors.profession ? "is-invalid" : ""
                    }`}
                    placeholder={watch("profession")}
                    list="select"
                    name="select"
                    {...register("profession", { required: true })}
                    onChange={handleChange}
                    onClick={clear}
                    onFocus={clear}
                  />
                  <datalist id="select">
                    {occupation.map((Profession) => {
                      return (
                        <option key={Profession.occupationId}>
                          {Profession.name}
                        </option>
                      );
                    })}
                  </datalist>
                </div>
              </div>
            </div>
            <div className="button-wrapper">
              <Button
                type="submit"
                className="text-light save_add_customer new_theme_btn"
              >
                <span>{t("Save Settings")}</span>
              </Button>
            </div>
          </form>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Information before we can register you")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {t(
              "To use our platform, we need you to enter your personal information here"
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>

      <OTPModalUI
        OTPModal={OTPModal}
        setOTPModal={setOTPModal}
        resendOTP={resendOTP}
        OTPField={OTPField}
        setOTPField={setOTPField}
        inputRefs={inputRefs}
        handleChangeOTP={handleChangeOTP}
        counter={counter}
        setCounter={setCounter}
      />
    </div>
  );
};

export default PersonalInformation;
